import { render } from "./Dental.vue?vue&type=template&id=7af2399a&scoped=true"
import script from "./Dental.vue?vue&type=script&lang=ts"
export * from "./Dental.vue?vue&type=script&lang=ts"

import "./Dental.vue?vue&type=style&index=0&id=7af2399a&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7af2399a"

export default script